import { render } from "./packageManagement.vue?vue&type=template&id=b14a9eac&scoped=true"
import script from "./packageManagement.vue?vue&type=script&lang=js"
export * from "./packageManagement.vue?vue&type=script&lang=js"

import "./packageManagement.vue?vue&type=style&index=0&id=b14a9eac&lang=scss&scoped=true"
import "./packageManagement.vue?vue&type=style&index=1&id=b14a9eac&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b14a9eac"]])

export default __exports__